import React from 'react';
import {
    FlexBox,
    Link,
    ModalDialog,
    ModalDialogBody,
    ModalDialogCloseButton,
    ModalDialogContent,
    ModalDialogHeader,
    ModalDialogNav,
    ModalDialogTitle,
    tokensRaw,
} from '@vp/swan';
import styled from 'styled-components';
import { __ } from '@99designs/i18n';
import { ToolbarButton } from '../ToolbarButton/ToolbarButton';
import { VistaLogo } from '../VistaLogo/VistaLogo';

export interface ToolbarMenuProps {
    menuButtonLabel: string;
    label: string;
    links: {
        label: string;
        path: string;
    }[];
    onLinkClick?: () => void;
    initialOpenState?: boolean;
}

const LogoLink = styled(Link)`
    line-height: 0;
    margin-bottom: ${tokensRaw.SwanSemSpace6};
`;

export const ToolbarMenu: React.FC<ToolbarMenuProps> = ({
    menuButtonLabel,
    label,
    links,
    onLinkClick,
    initialOpenState = false,
}) => {
    const [isMenuOpen, setIsMenuOpen] = React.useState(initialOpenState);

    return (
        <>
            <ToolbarButton onClick={() => setIsMenuOpen(true)} icon="menu">
                {menuButtonLabel}
            </ToolbarButton>
            <ModalDialog
                variant="menu"
                isOpen={isMenuOpen}
                onRequestDismiss={() => setIsMenuOpen(false)}
            >
                <ModalDialogContent aria-labelledby="modal dialog menu">
                    <ModalDialogNav>
                        <ModalDialogCloseButton accessibleText={__('Close')} />
                    </ModalDialogNav>
                    <LogoLink href="/" data-testid="vista-logo">
                        <VistaLogo width="32" height="28" />
                    </LogoLink>
                    <ModalDialogHeader>
                        <ModalDialogTitle>{label}</ModalDialogTitle>
                    </ModalDialogHeader>
                    <ModalDialogBody>
                        <FlexBox flexDirection="column" gap={'4'}>
                            {links.map((link) => (
                                <Link
                                    key={link.path}
                                    href={link.path}
                                    onClick={onLinkClick}
                                    skin="unstyled"
                                >
                                    {link.label}
                                </Link>
                            ))}
                        </FlexBox>
                    </ModalDialogBody>
                </ModalDialogContent>
            </ModalDialog>
        </>
    );
};
